// import { AddBox } from './styles';

import cn from 'classnames';
import { useRef, useState } from 'react';
import useOutsideClickAndEscPress from '#hooks/useOutsideClickAndEscPress';
import {
  VerticalList,
  VerticalListProps
} from 'src/components/atoms/verticalList';
import { ContentWrapper, SelectBoxContainer, Arrow } from './styles';

interface Props
  extends Pick<VerticalListProps, 'onClick' | 'options' | 'fallback'> {
  isArrowUse?: boolean;
  value: string | number;
  disabled?: boolean;
  placeholder?: string;
  displayValue?: (value: string | number) => string;
}

export function SelecteScheduleBox({
  isArrowUse = true,
  value,
  options,
  fallback,
  placeholder,
  disabled,
  displayValue,
  onClick
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const selectBoxRef = useRef<HTMLDivElement>(null);

  const handleClickTrigger = () => {
    if (disabled) {
      return;
    }
    setIsOpen(prev => !prev);
  };

  const getDisplayValue = () => {
    if (!value) {
      return placeholder;
    }

    return displayValue ? displayValue(value) : value;
  };

  useOutsideClickAndEscPress(selectBoxRef, () => setIsOpen(false));

  return (
    <>
      <SelectBoxContainer ref={selectBoxRef} onClick={handleClickTrigger}>
        <ContentWrapper>
          <span className={cn({ placeholder: !value, disabled })}>
            {getDisplayValue()}
          </span>
        </ContentWrapper>
        <VerticalList
          value={value}
          isOpen={isOpen}
          options={options}
          onClick={onClick}
          fallback={fallback}
          placeholder={placeholder}
        />
        <Arrow isUse={isArrowUse} />
      </SelectBoxContainer>
    </>
  );
}
